import React, { useReducer, useEffect, useState } from 'react';
import moment from 'moment';
import { useHistory } from "react-router-dom";
import clsx from 'clsx';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DateRangeRoundedIcon from '@material-ui/icons/DateRangeRounded';
import { TextField, MenuItem, Select, Grid, FormControl, Typography } from '@material-ui/core';

import ProfileContext from '../../context/profile-context';
import profileReducer from '../../reducers/profile-reducer';
import { getIslandScores } from '../../actions/home-actions';
import { GetStudentGrowthTraitGroups } from '../../actions/profile-actions';
import { getGetMonsterDetailByStudentNumber } from '../../actions/monster-actions';

import Badges from './Badges';
import GrowthStudentChart from './GrowthStudentChart';
import { DefaultLayout } from '../shared/component'
import { getIconProfile } from '../../utils/helpers/icon/iconHelper';
import useStyles from '../../styles/components/profile/styleProfile'
import { getStudentNumberFromSession } from '../../utils/helpers/others/SessionHelper'
import { Claims } from '../../utils/services/cache/ClientCache'


const Profile = () => {
    const history = useHistory();
    const [traitGroupItems, setTraitGroupItems] = useState([]);
    const [traitGroupId, setTraitGroupId] = useState(0);
    const [profileContext, dispatch] = useReducer(profileReducer);
    const classes = useStyles()
    const [showDate, setShowDate] = useState('')
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [avatar, setAvatar] = useState('');

    useEffect(() => {
        initAvatar();
        initTraitGroup();
        handleChangeStartDate(new Date())
    }, [])

    useEffect(() => {
        if (startDate !== endDate) {
            initGrowth()
        }
    }, [traitGroupId, showDate])

    const initTraitGroup = async () => {
        const response = await getIslandScores();
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }
        if (response.status === "Success") {
            const traitGroupItems = response.data;
            setTraitGroupItems(traitGroupItems)
            dispatch({ type: 'SET_TRAITGROUP_ITEM', traitGroupItems })
        }
    }

    const initAvatar = async () => {
        const response = await getGetMonsterDetailByStudentNumber(getStudentNumberFromSession());
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }
        if (response.status === "Success") {

            let monsterMenu = {
                open: false,
                cluster: response.data.monsterCluster,
                monsterLvl: response.data.monsterLvl,
                moodMeter: response.data.moodMeter,
                feedCount: response.data.feedCount,
                isMissing: response.data.isMissing,
                messages: response.data.messages
            }
            switch (monsterMenu.cluster) {

                case "ICT":
                    monsterMenu.monsterLvl > 0 ?
                        setAvatar(getIconProfile().img_profile_ict) : setAvatar(getIconProfile().img_profile_ict_egg);
                    break;
                case "CEFT":
                    monsterMenu.monsterLvl > 0 ?
                        setAvatar(getIconProfile().img_profile_ceft) : setAvatar(getIconProfile().img_profile_ceft_egg);
                    break;
                case "DSB":
                    monsterMenu.monsterLvl > 0 ?
                        setAvatar(getIconProfile().img_profile_dsb) : setAvatar(getIconProfile().img_profile_dsb_egg);
                    break;
                case "HSS":
                    monsterMenu.monsterLvl > 0 ?
                        setAvatar(getIconProfile().img_profile_hss) : setAvatar(getIconProfile().img_profile_hss_egg);
                    break;
                case "ENG":
                    monsterMenu.monsterLvl > 0 ?
                        setAvatar(getIconProfile().img_profile_eng) : setAvatar(getIconProfile().img_profile_eng_egg);
                    break;
            }

        }
    }

    const initGrowth = async () => {
        const response = await GetStudentGrowthTraitGroups(
            moment(new Date(startDate)).format('DD/MM/YYYY hh:mm:ss'),
            moment(new Date(endDate)).format('DD/MM/YYYY hh:mm:ss'),
            traitGroupId
        )
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }

        dispatch({ type: 'SET_DATA_GROWTH_CHART', dataGrowthChart: response.data })
    }

    const handleChange = (event) => {
        setTraitGroupId(event.target.value)
        dispatch({ type: 'SET_ID_TRAITGROUP_ITEM', idTraitGroupItems: event.target.value })
    }

    const handleChangeStartDate = (date) => {
        if (date <= new Date()) {
            const end = date;
            let start = moment(end).subtract(100, 'day')
            setStartDate(new Date(start))
            setEndDate(new Date(end))
            setShowDate(`${moment(start).format('DD/MM/YY')}  -  ${moment(end).format('DD/MM/YY')}`)
        }
    }

    const onDatepickerRef = (el) => {
        if (el && el.input) {
            el.input.readOnly = true;
        }
    }

    return (
        <ProfileContext.Provider value={{ profileContext, dispatch }}>
            <DefaultLayout
                title={Claims.getGivenName()}
                type='Learning Content'
                image={getIconProfile().img_profile_bg}
                avatar={avatar}
                profile="true"
            >

                <Grid item xs={12} sm={12} md={10} className={classes.rootProfile}>
                    <div className={classes.rootInfo}>
                        <Grid container >
                            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <TextField
                                    id="outlined-secondary-id"
                                    defaultValue={getStudentNumberFromSession()}
                                    variant="outlined"
                                    color="secondary"
                                    fullWidth
                                    disabled
                                    className={clsx(classes.rootNicknameTextfield, classes.resizeText)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="outlined-secondary-name"
                                    variant="outlined"
                                    color="secondary"
                                    defaultValue={Claims.getGivenName()}
                                    fullWidth
                                    disabled
                                    className={clsx(classes.rootNameTextfield, classes.resizeText)}
                                />
                            </Grid>
                        </Grid>
                        <TextField
                            id="outlined-secondary-email"
                            defaultValue={`${Claims.getGivenName()}@sit.singaporetech.edu.sg`}
                            variant="outlined"
                            color="secondary"
                            disabled
                            fullWidth
                            className={clsx(classes.rootEmailTextfield, classes.resizeText)}
                        />
                    </div>
                    <div className={classes.rootChart}>
                        <div style={{ display: 'block', textAlign: 'center' }}>
                            <Typography variant="h4" gutterBottom style={{ marginBottom: 15 }}>
                                Achievement Badges
                            </Typography>

                            {profileContext &&
                                <Badges />
                            }
                        </div>
                    </div>
                    <div className={classes.rootChart}>
                        <Grid container justify='space-around' alignItems='center' classes={{ root: classes.rootGridHead }}>

                            <FormControl variant="outlined" fullWidth margin="normal" className={clsx(classes.outlineSelect, classes.resizeText)}>
                                <Select
                                    classes={{ root: classes.rootSelect }}
                                    onChange={event => handleChange(event)}
                                    value={traitGroupId}>
                                    <MenuItem value={0}> Please select an option </MenuItem>
                                    {
                                        (traitGroupItems).map(traitGroupItem => (
                                            <MenuItem value={traitGroupItem.traitGroupId} key={traitGroupItem.traitGroupId}> {traitGroupItem.traitGroupName} </MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>


                            <Grid item xs={6} classes={{ root: classes.rootDatePicker }}>
                                <label htmlFor="date-picker-start" className={classes.labelTimePicker}>
                                    <DatePicker
                                        ref={el => onDatepickerRef(el)}
                                        id="date-picker-start"
                                        placeholderText="End date"
                                        value={showDate}
                                        selected={endDate}
                                        onChange={(date) => handleChangeStartDate(date)}
                                        selectsStart
                                        startDate={startDate}
                                        endDate={endDate}
                                        className={clsx(classes.datePicker)}
                                        calendarClassName={clsx(classes.customCelendar)}
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                    />
                                    <div className={classes.icon}><DateRangeRoundedIcon classes={{ root: classes.iconDatePicker }} /></div>
                                </label>
                            </Grid>

                        </Grid>

                        {profileContext &&
                            <GrowthStudentChart />
                        }

                    </div>
                </Grid>
            </DefaultLayout>
        </ProfileContext.Provider>
    )
}

export default Profile;